.placeholderBackground {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100%;
    flex-direction: column;
}

.animation {
    width: 400px;
}